"use client"

/**
 * 07 — Supplementary insurance may cover part of it. Figma 314:10935. The
 * section itself is shared (`components/ui/insurer-marquee-section.tsx`) so
 * the other main pages show insurance the same way; this block adds the
 * homepage's copy.
 */

import { useLocalePath } from "@/lib/use-localized-navigation"
import { InsurerMarqueeSection } from "@/components/ui/insurer-marquee-section"
import { useHomeV4Copy } from "./home-v4-copy"
import type { HomeV4Insurer } from "./home-v4-insurers"

export function HomeV4Insurance({
  section,
  insurers,
  tone,
}: {
  section: string
  insurers: HomeV4Insurer[]
  tone?: "white" | "grey"
}) {
  const lp = useLocalePath()
  const { INSURANCE } = useHomeV4Copy()
  return (
    <InsurerMarqueeSection
      section={section}
      eyebrow={INSURANCE.eyebrow}
      heading={INSURANCE.heading}
      body={INSURANCE.body}
      ctaLabel={INSURANCE.cta}
      ctaHref={lp("/insurance")}
      insurers={insurers}
      tone={tone}
    />
  )
}
